import Reveal from "@/components/base/Reveal";
import { whatsappLink } from "@/constants/site";

const OLD_SITE_ISSUES = [
  "Demora para abrir e o visitante desiste antes de ver o conteúdo",
  "Perde posição no Google para sites mais rápidos",
  "Vender ou gerar contato fica muito mais difícil",
];

const NX_SITE_WINS = [
  "Páginas leves, que abrem rápido no celular e no computador",
  "Estrutura otimizada que ajuda no ranqueamento do Google",
  "Mais visitas que ficam, leem e entram em contato",
];

const STATS = [
  { value: "53%", label: "das visitas pelo celular abandonam sites que demoram mais de 3 segundos" },
  { value: "1s", label: "de atraso a mais pode derrubar bastante a taxa de conversão" },
  { value: "3s", label: "é o tempo máximo que boa parte dos usuários espera pela página" },
];

export default function SpeedComparison() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
              <i className="ri-timer-flash-line" aria-hidden="true"></i>
              Velocidade
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Site lento faz você perder clientes todos os dias.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Um site antigo e pesado demora para abrir — e o visitante vai embora antes mesmo de
              conhecer a sua empresa. Já um site rápido mantém a pessoa na página e convida à ação.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col rounded-2xl bg-foreground-950 p-6 text-background-50 md:p-8">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                  <i className="ri-alarm-warning-line text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-heading text-base font-semibold">Site antigo e lento</p>
                  <p className="text-xs text-background-400">O visitante não espera</p>
                </div>
              </div>
              <ul className="mt-6 flex flex-1 flex-col gap-4">
                {OLD_SITE_ISSUES.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-background-200">
                    <i className="ri-close-circle-line mt-0.5 text-lg text-accent-300" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex items-center gap-2 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3">
                <i className="ri-emotion-unhappy-line text-lg text-accent-300" aria-hidden="true"></i>
                <p className="text-xs text-background-300">
                  Resultado: menos visitas, menos contatos e menos vendas.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex h-full flex-col rounded-2xl border border-secondary-200 bg-background-50 p-6 md:p-8">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className="ri-flashlight-fill text-xl" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-heading text-base font-semibold text-foreground-950">
                    Site NXHOST otimizado
                  </p>
                  <p className="text-xs text-foreground-500">Rápido e pronto para converter</p>
                </div>
              </div>
              <ul className="mt-6 flex flex-1 flex-col gap-4">
                {NX_SITE_WINS.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line mt-0.5 text-lg text-secondary-600" aria-hidden="true"></i>
                    {item}
                  </li>
                ))}
              </ul>
              <a
                href={whatsappLink("Ola! Meu site atual esta lento e quero um site rapido com a NXHOST.")}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
              >
                Quero um site rápido
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </Reveal>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {STATS.map((stat, index) => (
            <Reveal key={stat.value} delay={index * 80} className="h-full">
              <div className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6">
                <p className="font-heading text-3xl font-bold text-accent-600">{stat.value}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-6 text-center text-xs text-foreground-500">
            Dados de referência do mercado sobre velocidade e abandono de páginas.
          </p>
        </Reveal>
      </div>
    </section>
  );
}